import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { initConsent } from './lib/consent';
import './index.css';

// Boot-time consent wiring: honor Sec-GPC if the browser signals it, and
// replay any consent logs that failed to POST on a prior visit. Runs once
// before React mounts so ConsentBanner reads the post-GPC state.
initConsent();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
